import * as Styled from '../Reports.styles';

import { ReportTileProps } from './ReportTile.types';

export const ReportTile = ({ icon, name, onClick }: ReportTileProps) => {
  return (
    <Styled.ReportTile onClick={onClick}>
      {icon}
      <Styled.ReportTitle>{name}</Styled.ReportTitle>
    </Styled.ReportTile>
  );
};
